<template>
    <!-- v-once で描画を初回だけにしないと、親コンポーネントのv-modelで再描画された際に、フォントサイズがもとに戻ってしまう -->
    <div v-once :style="style">
        <slot>項目名</slot>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                style: {
                    "display" : "grid",
                    "height": this.height + "px",
                    "width": this.width + "px",
                    "font-size": "1.92rem",
                    "font": this.font,
                    "color": this.color,
                    "font-weight": this.fontWeight,
                    "justify-items": this.horizontal,
                    "align-items": this.vertical,
                    "padding-right": this.paddingRight + "px",
                    "padding-left": this.paddingLeft + "px",
                },
            }
        },
        props: {
            // 要素の高さ
            height: {
                type: String,
                default: "56"
            },
            // 要素の横幅
            width: {
                type: String,
            },
            // フォントサイズ
            fontSize: {
                type: String,
                default: "20"
            },
            // フォント
            font: {
                type: String,
            },
            // フォントの太さ
            fontWeight: {
                type: String,
            },
            // カラー
            color: {
                type: String,
            },
            // 横方向
            horizontal: {
                type: String,
                default: "center"
            },
            // 縦方向
            vertical: {
                type: String,
                default: "center"
            },
            // 右の空白のサイズ
            paddingRight: {
                type: String,
            },
            // 左の空白のサイズ
            paddingLeft: {
                type: String,
            }

        },
    }
</script>